export default "/images/logo-3.png?e1705c3fc0476560c3307b7462fde46d";